import Presenter from './Presenter';
import { IContainerProps } from './types';

const BusinessCardContainer = (props: IContainerProps) => {

    return (
        <Presenter {...props} />
    );
};

export default BusinessCardContainer;
